<!-- Pills Section -->
<div class="Notification-pills u-spacing-lg-mb">
    <div class="flex Notification-pills--truncate">
        @if (notification().events.length === 1) {
            <ce-pill state="default" ce-pill-xs ce-pill-secondary class="u-spacing-sm-mr">
                {{ notification().vehicleNames.join(', ') }}
            </ce-pill>
        } @else if (notification().events.length > 1) {
            <ce-pill state="default" ce-pill-xs ce-pill-secondary class="u-spacing-sm-mr">
                {{ notification().events.length }} EVs
            </ce-pill>
        }
    </div>
    <div class="flex flex-end">
        @if (notification().archived) {
            <ce-pill [state]="'default'" icon="archive" ce-pill-xs ce-pill-secondary class="u-spacing-sm-mr">Archived</ce-pill>
        }
        @if (notification().eventState === 'active') {
            <ce-pill [state]="'info'" ce-pill-xs ce-pill-secondary>Active</ce-pill>
        } @else {
            <span class="u-text-body-xs u-color-text-secondary">Resolved</span>
        }
    </div>
</div>

<!-- Summary Text -->
<p class="Notification-summary u-text-body-lg">{{ notification().body }}</p>

<!-- Action Button -->
<a
    [routerLink]="detailsUrl()"
    ce-button
    ce-button-small
    ce-button-type-tertiary
    class="u-spacing-xl-mt u-spacing-2xl-mb"
>
    {{ linkLabel() }}
</a>

<!-- Parameter List -->
<ce-parameter-list size="small">
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>
            @if (hasMultipleEvents()) {
                First event occurred
            } @else {
                Event occurred
            }
        </span>
        <span ceParameterItemValue class="u-text-align-right">{{ notification().eventTimestamp }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Notification sent</span>
        <span ceParameterItemValue class="u-text-align-right">{{ notification().notificationTimestamp }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>
            @if (hasMultipleEvents()) {
                Events resolved
            } @else {
                Event resolved
            }
        </span>
        @if (notification().eventResolvedTimestamp) {
            <span ceParameterItemValue class="u-text-align-right">{{ notification().eventResolvedTimestamp }}</span>
        } @else {
            <span ceParameterItemValue class="u-text-placeholder u-text-align-right">Not yet resolved</span>
        }
    </ce-parameter-item>
    @if (showResolutionReason()) {
        <ce-parameter-item [orientation]="'horizontal'">
            <span ceParameterLabel>Resolution reason</span>
            <span ceParameterItemValue class="u-text-align-right">{{ notification().events[0].resolutionReason }}</span>
        </ce-parameter-item>
    }
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>
            @if (hasMultipleEvents()) {
                EVs
            } @else {
                EV
            }
        </span>
        <span ceParameterItemValue class="u-text-align-right">{{ notification().vehicleNames.join(', ') }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Email notification</span>
        <span ceParameterItemValue class="u-text-align-right">
            @if (emailTimestamp()?.timestamp) {
                Sent
            } @else {
                Not sent
            }
        </span>
    </ce-parameter-item>
</ce-parameter-list>
